export default __webpack_public_path__ + "static/media/gratipay.bcde6930.svg";